import { PerformanceRiskAnalysis } from './analysis/performance-risk-analysis.model';
import { RobustnessAnalysis } from './analysis/robustness-analysis.model';
import { PeerAnalysis } from "./analysis/peer-analysis.model";
import { FactorAnalysis } from "./analysis/factor-analysis.model";

export class CurrentStrategyTarget {
  public id: number;
  public name: string;
  public benchmark_id: number;
  public strategy_target_id: number;
  public investable_portfolio_id: number;
  public investment_zone: string;
  public currency: string;
  public market_position: string;
  public asset_class: string;
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public peer_analysis: PerformanceRiskAnalysis;
  public performance_risk_analysis: PeerAnalysis;
  public factor_analysis: FactorAnalysis;
  public robustness_analysis: RobustnessAnalysis;

  public performanceRiskAnalysis: PerformanceRiskAnalysis;
  public peerAnalysis: PeerAnalysis;
  public factorAnalysis: FactorAnalysis;
  public robustnessAnalysis: RobustnessAnalysis;

  constructor(id: number) {
    this.id = id;
  }

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.name                      = data.name ? data.name : undefined;
    this.benchmark_id              = data.benchmark_id ? data.benchmark_id : undefined;
    this.strategy_target_id        = data.strategy_target_id ? data.strategy_target_id : undefined;
    this.investable_portfolio_id   = data.investable_portfolio_id ? data.investable_portfolio_id : undefined;
    this.investment_zone           = data.investment_zone ? data.investment_zone : undefined;
    this.currency                  = data.currency ? data.currency : undefined;
    this.market_position           = data.market_position ? data.market_position : undefined;
    this.asset_class               = data.asset_class ? data.asset_class : undefined;
    this.creation_date             = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date            = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date                 = data.last_date ? new Date(data.last_date) : undefined;

    this.peer_analysis             = data.peer_analysis ? data.peer_analysis : undefined;
    this.performance_risk_analysis = data.performance_risk_analysis ? data.performance_risk_analysis : undefined;
    this.factor_analysis           = data.factor_analysis ? data.factor_analysis : undefined;
    this.robustness_analysis       = data.robustness_analysis ? data.robustness_analysis : undefined;

    this.peerAnalysis = new PeerAnalysis();
    this.performanceRiskAnalysis = new PerformanceRiskAnalysis();
    this.factorAnalysis = new FactorAnalysis();
    this.robustnessAnalysis = new RobustnessAnalysis();

    this.peerAnalysis.initFromData(this.peer_analysis);
    this.performanceRiskAnalysis.initFromData(this.performance_risk_analysis);
    this.factorAnalysis.initFromData(this.factor_analysis);
    this.robustnessAnalysis.initFromData(this.robustness_analysis);
  }

  loadDetails() {
    return new Promise(
      (resolve, reject) => {
        /*/ Load current portfolio from databae (requires backend)
        // TODO: Load current portfolio from databae
        /*/ // Fake current portfolio loading // FIXME: To remove when working with backend
        setTimeout(
          () => {
            this.initFromData({
              name: 'Strategy Target',
              benchmark_id: 1,
              strategy_target_id: 1,
              investable_portfolio_id: 2,
              protected_portfolio_id: 3,
              investment_zone: 'United States',
              currency: 'USD',
              market_position: 'Long Only',
              asset_class: 'Equity',
              ticker: 'BOSTONTICKER1234',
              strategy_target: 'Equal Factor Weights',
              creation_date: '2020-03-23',
              inception_date: "2002-06-21",
              last_date: "2019-11-29"
            });
            resolve({response: 'Successfully loaded strategy target details.'});
          }
          , 2000);
        //*/
      }
    );
  }
}
